import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  Select,
  InputLabel,
  MenuItem,
  Box,
  Stack,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { toast } from "react-toastify";
import axios from "axios";
import { serverUrl } from "../../server";
import Cookies from "js-cookie";

const defaultTheme = createTheme();

const AddBenne = () => {
  const token = Cookies.get("jwt");
  const [immat, setImmat] = useState("");
  const [proprioId, setProprioId] = useState("");
  const [propriosOptions, setPropriosOptions] = useState([]);

  const getProprios = async () => {
    await axios
      .get(`${serverUrl}/api/proprio/getproprios`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setPropriosOptions(response.data.proprios);
      })
      .catch((error) => {
        console.error(error);
        toast.error(error);
      });
  };

  useEffect(() => {
    getProprios();
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      immat: immat,
      proprio_id: proprioId,
    };
    axios
      .post(`${serverUrl}/api/benne/addbenne`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        toast.success("Benne ajoutée avec succès");
        setImmat("");
        setProprioId("");
      })
      .catch((error) => {
        console.error(error);
        toast.error(error);
      });
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <Box sx={{ mt: 3, mb: 3 }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Ajouter une Benne
          </Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Stack spacing={3}>
            <TextField
              required
              fullWidth
              id="immat"
              label="Immatriculation"
              name="immat"
              autoFocus
              value={immat}
              onChange={(e) => setImmat(e.target.value)}
            />
            <Box>
              <InputLabel id="proprioId-label">Propriétaire</InputLabel>
              <Select
                labelId="proprioId-label"
                id="proprioId"
                value={proprioId}
                onChange={(e) => setProprioId(e.target.value)}
                fullWidth
              >
                {propriosOptions.map((proprio) => (
                  <MenuItem key={proprio.id} value={proprio.id}>
                    {proprio.nom}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
              >
                Ajouter
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default AddBenne;
